import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Button, Stack, IconButton, Stepper, Step, StepLabel, StepConnector, stepConnectorClasses, TextField, useMediaQuery, Box, FormControl, MenuItem, useTheme, FormLabel, RadioGroup, DialogActions, DialogContent, DialogTitle, FormControlLabel, Dialog, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../../components/Header';
import Radio from '@mui/material/Radio';
import { useLocation, useNavigate } from 'react-router-dom';
import { addCommercialMarketing, editCommercialMarketing, getAllCommercialDealer, getAllCommercialProduct, getAllDealerProduct, getAllWarehouse, getCommercialMarketing, viewComerialMarketing } from '../../../redux/slice/Commercialmarketing.slice';
import { useState } from 'react';
import { useEffect } from 'react';
import { viewDealerMarketing } from '../../../redux/slice/dealer.slice';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DownloadIcon from '@mui/icons-material/Download';
import { Country, State, City } from 'country-state-city';
import AddIcon from '@mui/icons-material/Add';
import { BASE_URL, Image_URL } from '../../../utils/baseURL';
import axios from 'axios';
import axiosInstance from '../../../utils/axiosInstance';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
    }),
    ...(ownerState.error && {
        border: '2px solid red',
    }),
}));


function ColorlibStepIcon(props) {
    const { active, completed, className, icon, onClick, error, marketingType, theme } = props;
    const commercialIcons = {
        1: <img src="/assets/images/icons/file.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        2: <img src="/assets/images/icons/Customer.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        3: <img src="/assets/images/icons/ElectricityBillDetails.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        4: <img src="/assets/images/icons/BusinessDocumentDetails.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        5: <img src="/assets/images/icons/SystemSpecification1.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        6: <img src="/assets/images/icons/CustomerPrice.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        7: <img src="/assets/images/icons/DealerDetails.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
    };

    const residentialIcons = {
        1: <img src="/assets/images/icons/file.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        2: <img src="/assets/images/icons/Customer.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        3: <img src="/assets/images/icons/SystemSpecification1.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        4: <img src="/assets/images/icons/CustomerPrice.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        5: <img src="/assets/images/icons/DealerDetails.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,

    };
    const icons = marketingType == 'Commercial' ? commercialIcons : residentialIcons;

    return (
        <ColorlibStepIconRoot
            ownerState={{ completed, active, error }}
            className={className}
            onClick={onClick}
        >
            {icons[String(icon)]}
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    completed: PropTypes.bool,
    icon: PropTypes.node,
    onClick: PropTypes.func,
    error: PropTypes.bool,
    marketingType: PropTypes.string,
};

const commercialSteps = ['File No', 'Customer Basic Details', 'Electricity Bill Details', 'Business Document Details', 'System Specification', 'Customer Price', 'Dealer Details'];
const residentialSteps = ['File No', 'Customer  Details', 'System Specification', 'Customer Price', 'Dealer Details',];

const getValidationSchema = (marketingType, id) => {
    const commonFields = {
        MarketingType: Yup.string().required('Marketing Type is required'),
        Date: id
            ? Yup.date().required('Date is required') : Yup.date()
                .required('Date is required')
                .test('is-today', 'Date must be today', (value) => {
                    const today = new Date();
                    return value && value.getFullYear() === today.getFullYear() &&
                        value.getMonth() === today.getMonth() &&
                        value.getDate() === today.getDate();
                }),
        PhoneNumber: Yup.string().matches(/^[0-9]{10}$/, 'Phone Number must be exactly 10 digits').required('Phone Number is required'),
        Address: Yup.string().required('Address is required'),
        // country: Yup.string().required('Country is required'),
        state: Yup.string().required('State is required'),
        district: Yup.string().required('District is required'),
        City_Village: Yup.string().required('City/Village is required'),
        // District_Location: Yup.string().required('District/Location is required'),
        Pincode: Yup.string().matches(/^[0-9]{6}$/, 'Pincode must be exactly 6 digits').required('Pincode is required'),
        Latitude: Yup.string().required('Latitude is required'),
        ConsumerName: Yup.string().required('Consumer Name is required'),
        Longitude: Yup.string().required('Longitude is required'),
        ConsumerNumber: Yup.string().required('Consumer Number is required'),
        SystemSizeKw: Yup.string().required('System Size Kw is required'),
        // DealerCommission: Yup.string().required('Dealer Commission is required'),
        CommissionPerKW: Yup.string().required('Commission Per KW is required'),
        // TotalCommission: Yup.string().required('Total Commission is required'),
        ProductName: Yup.string().required('Product Name is required'),
        SolarModuleMake: Yup.string().required('Solar Module Make is required'),
        SolarModuleWp: Yup.string().required('Solar Module Wp is required'),
        SolarModuleNos: Yup.string().required('Solar Module Nos is required'),
        // Add validation for the inverter fields
        InverterName: Yup.string().required('Inverter Name is required'),
        InverterModuleMake: Yup.string().required('Inverter Module Make is required'),
        InverterModuleWp: Yup.string().required('Inverter Module Wp is required'),
        WarehouseId: Yup.string().required('Warehouse is required'),
        payment_as_loan: Yup.string().required('Recd Payment As a loan is required'),
        type_loan: Yup.string().required('Type of loan is required'),
    };

    if (marketingType === 'Commercial') {
        return Yup.object().shape({
            ...commonFields,
            Amount: Yup.string().required('Amount is required'),
            GST: Yup.string().required('GST is required'),
            ConnectionLoad: Yup.string().required('Connection Load is required'),
            ContactPersonName: Yup.string().required('Contact Person Name is required'),
            Tarrif: Yup.string().required('Tarrif is required'),
            AverageMonthlyBill: Yup.string().required('Average Monthly Bill is required'),
            GSTNumber: Yup.string().required('GST Number is required'),
            Phase: Yup.string().required('Phase is required'),
            PanNumber: Yup.string().required('Pan Number is required'),
            MSME_UdyamREGISTRATION: Yup.string().required('MSME/Udyam Registration is required'),
        });
    }

    return Yup.object().shape({
        ...commonFields,
        PrimaryAmount: Yup.string().required('Primary Amount is required'),
        CashAmount: Yup.string().required('Cash Amount is required'),
        SolarModuleMake: Yup.string().required('Solar Module Make is required'),
        // DealerPolicy: Yup.string().required('Dealer Policy is required'),
        SolarModuleWp: Yup.string().required('Solar Module Wp is required'),
        SolarModuleNos: Yup.string().required('Solar Module Nos is required'),
    });
};

const initialValues = {
    MarketingType: '',
    WarehouseId: '',
    Date: '',
    payment_as_loan: '',
    type_loan: '',
    country: '',
    state: '',
    district: '',
    ConsumerName: '',
    ContactPersonName: '',
    PhoneNumber: '',
    Address: '',
    City_Village: '',
    Pincode: '',
    Latitude: '',
    Amount: '',
    GST: '',
    TotalAmount: '',
    Dealer: null,
    ProductName: '',
    // DealerCommission: '',
    CommissionPerKW: '',
    TotalCommission: '',
    ConsumerNumber: '',
    ConnectionLoad: '',
    Tarrif: '',
    AverageMonthlyBill: '',
    GSTNumber: '',
    PanNumber: '',
    MSME_UdyamREGISTRATION: '',
    PrimaryAmount: '',
    CashAmount: '',
    Phase: '',
    SolarModuleMake: '',
    SolarModuleWp: '',
    SolarModuleNos: '',
    SystemSizeKw: '',
    InverterSize: '',
    DealerPolicy: '',
    MultipleDetails: [{
        inputField: '',
        dealerImage: ''
    }],
    InverterModuleWp: '',
    InverterModuleMake: '',
    InverterName: '',
};


const errorBelongsToStep = (errorKey, stepIndex, marketingType) => {
    if (marketingType === 'Commercial') {
        switch (stepIndex) {
            case 0:
                return ['MarketingType', 'Date', 'payment_as_loan', 'type_loan'].includes(errorKey);
            case 1:
                return ['ConsumerName', 'ContactPersonName', 'PhoneNumber', 'country', 'state', 'district', 'Address', 'City_Village',
                    'Pincode', 'Latitude', 'Longitude', 'WarehouseId'].includes(errorKey);
            case 2:
                return ['Amount', 'GST', 'TotalAmount'].includes(errorKey);
            case 3:
                return ['GSTNumber', 'PanNumber', 'MSME_UdyamREGISTRATION', 'SystemSizeKw', 'ProductName'].includes(errorKey);
            case 4:
                return ['ProductName', 'SolarModuleMake', 'SolarModuleWp', 'SolarModuleNos',
                    'SystemSizeKw', 'InverterName', 'InverterModuleMake', 'InverterModuleWp'].includes(errorKey);
            case 5:
                return ['ConsumerNumber', 'ConnectionLoad', 'Tarrif', 'AverageMonthlyBill', 'Phase'].includes(errorKey);
            case 6:
                return ['Dealer', 'CommissionPerKW', 'TotalCommission'].includes(errorKey);
            default:
                return false;
        }
    } else if (marketingType === 'Residential') {
        switch (stepIndex) {
            case 0:
                return ['MarketingType', 'Date', 'payment_as_loan', 'type_loan'].includes(errorKey);
            case 1:
                return ['ConsumerName', 'WarehouseId', 'PhoneNumber', 'ConsumerNumber', 'Address', 'City_Village',
                    'country', 'state', 'district',

                    'Pincode', 'Latitude', 'Longitude'].includes(errorKey);
            case 2:
                return ['PrimaryAmount', 'CashAmount', 'TotalAmount',].includes(errorKey);
            case 3:
                return ['Dealer', 'DealerPolicy', 'CommissionPerKW', 'TotalCommission'].includes(errorKey);
            case 4:
                return ['ProductName', 'SolarModuleMake', 'SolarModuleWp', 'SolarModuleNos',
                    'SystemSizeKw', 'InverterName', 'InverterModuleMake', 'InverterModuleWp'].includes(errorKey);
            default:
                return false;
        }
    }
    return false;
};

export default function Marketing() {

    const location = useLocation();

    const { id, dealerset, dealerName, adminId, adminName, ConsumerNumberL } = location.state || {};

    // console.log(dealerName, location.state, dealerset, adminId, adminName);



    const [activeStep, setActiveStep] = React.useState(0);
    const [marketingType, setMarketingType] = React.useState('');
    const [dealarData, setDealarData] = useState('');
    const [fileNo, setFileNo] = useState('');
    const [dealer, setDealar] = useState([]);
    const [validationSchema, setValidationSchema] = useState(getValidationSchema(marketingType, id));
    const [inputFields, setInputFields] = React.useState(dealarData.MultipleDetails || initialValues.MultipleDetails || []);
    const [changeimageMultiple, setchangeimageMultiple] = React.useState([{ changed: false, index: 0 }]);
    const downloadRef = React.useRef(null);
    const imgUrl = Image_URL;
    const userId = localStorage.getItem("id");
    const [Error, setError] = React.useState('');
    const [ConsumerNameError, setConsumerNameError] = React.useState('');
    const [ContactPersonNameError, setContactPersonNameError] = React.useState('');
    const [PhoneError, setPhoneError] = React.useState('');
    const [AddressError, setAddressError] = React.useState('');
    const [CityVillageError, setCityVillageError] = React.useState('');
    const [PincodeError, setPincodeError] = React.useState('');
    const [LatitudeError, setLatitudeError] = React.useState('');
    const [LongitudeError, setLongitudeError] = React.useState('');
    const [AmountError, setAmountError] = React.useState('');
    const [GSTError, setGSTError] = React.useState('');
    const [TotalAmountError, setTotalAmountError] = React.useState('');
    const [GSTNumberError, setGSTNumberError] = React.useState('');
    const [PanNumberError, setPanNumberError] = React.useState('');
    const [MSMEUdyamREGISTRATIONError, setMSMEUdyamREGISTRATIONError] = React.useState('');
    const [ConnectionLoadError, setConnectionLoadError] = React.useState('');
    const [TarrifError, setTarrifError] = React.useState('');
    const [AverageMonthlyBillError, setAverageMonthlyBillError] = React.useState('');
    const [ConsumerNumberError, setConsumerNumberError] = React.useState('');
    const [CommissionPerKWError, setCommissionPerKWError] = React.useState('');
    const isMobile = useMediaQuery('(max-width:500px)');

    const [nextFillNo, setNextFillNo] = useState("");


    useEffect(() => {
        const fetchPreview = async () => {
            try {
                if (!id) {
                    const res = await axiosInstance.get(BASE_URL + "/previewNextFileNo");
                    setNextFillNo(res.data.fillNo);
                }

            } catch (err) {
                console.error("Error fetching preview FillNo:", err);
            }
        };

        fetchPreview();
    }, []);


    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(getCommercialMarketing());
        dispatch(getAllWarehouse());
        dispatch(getAllCommercialProduct());
        dispatch(getAllCommercialDealer());
        dispatch(getAllDealerProduct());
    }, []);



    useEffect(() => {
        if (id) {
            dispatch(viewComerialMarketing(id)).then((response) => {
                if (response.payload && response.payload.CommercialMarket) {
                    const MarketingData = response.payload.CommercialMarket;
                    setInputFields([...MarketingData.MultipleDetails]);
                    if (MarketingData.country) {
                        const countryStates = State.getStatesOfCountry(MarketingData.country);
                        setStates(countryStates);

                        if (MarketingData.state) {
                            const stateCities = City.getCitiesOfState(MarketingData.country, MarketingData.state);
                            setDistricts(stateCities);
                        }
                    }
                    const initialChangeImage = MarketingData.MultipleDetails?.map((payment, index) => ({
                        changed: false,
                        index: index,
                    }));



                    setchangeimageMultiple(initialChangeImage);
                    dispatch(viewDealerMarketing(MarketingData.Dealer));
                    setValues(MarketingData);
                    setMarketingType(MarketingData.MarketingType);
                }
            });
        }
    }, [id, dispatch]);

    const Warehouse = useSelector(state => state.comMarketing.warehouseUsers);
    const product = useSelector(state => state.comMarketing.allProducts);
    const CommercialMarket = useSelector(state => state.comMarketing?.Marketing);
    const Commmercialdealer = useSelector(state => state.comMarketing.dealers);




    useEffect(() => {
        if (!id) {
            if (CommercialMarket && CommercialMarket.length === 0) {
                setFileNo('A001');
            }
            else if (CommercialMarket && CommercialMarket.length > 0) {
                let n = CommercialMarket.length;
                let lastFillNo = CommercialMarket[n - 1]?.fillNo;

                if (lastFillNo) {
                    const prefix = lastFillNo.charAt(0);
                    let sequenceNumber = parseInt(lastFillNo.substr(1));

                    if (sequenceNumber >= 999) {
                        const nextPrefix = String.fromCharCode(prefix.charCodeAt(0) + 1);
                        if (nextPrefix > 'Z') {
                            setFileNo('A001');
                        } else {
                            setFileNo(`${nextPrefix}001`);
                        }
                    } else {
                        sequenceNumber++;
                        setFileNo(`${prefix}${sequenceNumber.toString().padStart(3, '0')}`);
                    }
                } else {
                    setFileNo('A001');
                }
            }
        } else {
            if (Array.isArray(CommercialMarket)) {
                const updateFillNo = CommercialMarket.find(item => item._id === id);
                if (updateFillNo) {
                    setFileNo(updateFillNo.fillNo);
                }
            }
        }
    }, [CommercialMarket, id]);

    useEffect(() => {
        if (dealerset) {
            dispatch(viewDealerMarketing(dealerset)).then((response) => {
                if (response.payload) {
                    const data = response.payload;
                    setDealarData({
                        ...data,
                        Dealer: data._id,
                        MultipleDetails: data.MultipleDetails.map(detail => ({
                            ...detail,
                            dealerImage: detail.dealerImage instanceof File ? detail.dealerImage.name : detail.dealerImage
                        }))
                    });
                    const initialChangeImage = data.MultipleDetails.map((payment, index) => ({
                        changed: false,
                        index: index,
                    }));
                    setchangeimageMultiple(initialChangeImage);
                    setValues(data);
                    setMarketingType(data.MarketingType);
                    setInputFields([...data.MultipleDetails]);
                }
            }).catch(error => {
                console.error("Error fetching data:", error);
            });
        }
    }, [dispatch, CommercialMarket, dealerset]);

    // console.log(CommercialMarket);


    const handleNext = (values) => {
        // console.log("dealerset || values.Dealer", dealerset, values);

        // let flag = false;

        // CommercialMarket.map((v) => {
        //     if (v.ConsumerNumber === values.ConsumerNumber && values.ConsumerNumber !== ConsumerNumberL) {
        //         flag = true;
        //     }
        // });

        const flag = CommercialMarket.some((v) =>
            v.ConsumerNumber === values.ConsumerNumber &&
            v.ConsumerNumber !== ConsumerNumberL
        );

        // console.log("ConsumerNumberL", ConsumerNumberL);


        if (flag) {
            alert("Consumer Number already exist");
            return;
        }


        if (!isLastStep) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } else {
            setTouchedSteps(steps.map(() => true));

            validateForm().then((formErrors) => {
                const newStepsWithErrors = steps.map(() => false);

                Object.keys(formErrors).forEach((errorKey) => {
                    steps.forEach((_, stepIndex) => {
                        if (errorBelongsToStep(errorKey, stepIndex, values.MarketingType)) {
                            newStepsWithErrors[stepIndex] = true;
                        }
                    });
                });

                setStepsWithErrors(newStepsWithErrors);

                if (Object.keys(formErrors).length === 0) {
                    let submissionValues;
                    const totalCommission = (values.SystemSizeKw * values.CommissionPerKW).toFixed(2) === 'NaN' ? '0' : (values.SystemSizeKw * values.CommissionPerKW).toFixed(2);
                    const commonFields = {
                        MarketingType: values.MarketingType,
                        Date: values.Date,
                        payment_as_loan: values.payment_as_loan,
                        type_loan: values.type_loan,
                        PhoneNumber: values.PhoneNumber,
                        Address: values.Address,
                        country: values.country,
                        state: values.state,
                        district: values.district,
                        City_Village: values.City_Village,
                        Dealer: dealerset || values.Dealer || adminId,
                        // District_Location: values.District_Location,
                        Pincode: values.Pincode,
                        Latitude: values.Latitude,
                        ProductName: values.ProductName,
                        ConsumerName: values.ConsumerName,
                        Longitude: values.Longitude,
                        ConsumerNumber: values.ConsumerNumber,
                        // adharCard: values.adharCard,
                        // lightBill: values.lightBill,
                        // veraBill: values.veraBill,
                        SystemSizeKw: values.SystemSizeKw,
                        // DealerCommission: values.DealerCommission,
                        CommissionPerKW: values.CommissionPerKW,
                        TotalCommission: totalCommission,
                        userId: values.userId,
                        InverterModuleWp: values.InverterModuleWp,
                        InverterModuleMake: values.InverterModuleMake,
                        SolarModuleWp: values.SolarModuleWp,
                        SolarModuleNos: values.SolarModuleNos,
                        SolarModuleMake: values.SolarModuleMake,
                        InverterName: values.InverterName,
                        amount: values.amount,
                        WarehouseId: values.WarehouseId,
                        MultipleDetails: values.MultipleDetails.map(detail => ({
                            ...detail,
                            dealerImage: detail.dealerImage instanceof File ? detail.dealerImage.name : detail.dealerImage
                        }))
                    };

                    if (values.MarketingType === 'Commercial') {
                        submissionValues = {
                            ...commonFields,
                            Amount: values.Amount,
                            GST: values.GST,
                            ConnectionLoad: values.ConnectionLoad,
                            ContactPersonName: values.ContactPersonName,
                            Tarrif: values.Tarrif,
                            AverageMonthlyBill: values.AverageMonthlyBill,
                            GSTNumber: values.GSTNumber,
                            Phase: values.Phase,
                            PanNumber: values.PanNumber,
                            MSME_UdyamREGISTRATION: values.MSME_UdyamREGISTRATION,
                            TotalAmount: Number(values.Amount) + Number(values.GST),
                        };
                    } else if (values.MarketingType === 'Residential') {
                        submissionValues = {
                            ...commonFields,
                            PrimaryAmount: values.PrimaryAmount,
                            CashAmount: values.CashAmount,
                            TotalAmount: Number(values.PrimaryAmount) + Number(values.CashAmount),
                        };
                    }
                    // 

                    if (id) {
                        delete submissionValues.isActive;
                        delete submissionValues.createdAt;
                        delete submissionValues.updatedAt;
                        dispatch(editCommercialMarketing({ id: values._id, ...submissionValues })).then(() => {
                            dispatch(getCommercialMarketing());
                        });
                    } else {
                        dispatch(addCommercialMarketing({ ...submissionValues })).then(() => {
                            dispatch(getCommercialMarketing());
                            localStorage.removeItem("pending_id");
                        });


                    }
                    // 

                    navigate('/admin/list-of-customer');
                    setActiveStep(0);
                    setStepsWithErrors(steps.map(() => false));
                } else {


                    if (values.MarketingType === 'Commercial') {

                        setFieldTouched('MarketingType', true);
                        setFieldTouched('Date', true);
                        setFieldTouched('payment_as_loan', true);
                        setFieldTouched('type_loan', true);
                        setFieldTouched('WarehouseId', true);
                        setFieldTouched('ConsumerName', true);
                        setFieldTouched('ContactPersonName', true);
                        setFieldTouched('PhoneNumber', true);
                        setFieldTouched('Address', true);
                        setFieldTouched('state', true);
                        setFieldTouched('district', true);
                        setFieldTouched('City_Village', true);
                        setFieldTouched('Pincode', true);
                        setFieldTouched('Latitude', true);
                        setFieldTouched('Longitude', true);
                        setFieldTouched('Amount', true);
                        setFieldTouched('GST', true);
                        setFieldTouched('GSTNumber', true);
                        setFieldTouched('PanNumber', true);
                        setFieldTouched('MSME_UdyamREGISTRATION', true);
                        setFieldTouched('SystemSizeKw', true);
                        setFieldTouched('ProductName', true);
                        setFieldTouched('SolarModuleMake', true);
                        setFieldTouched('SolarModuleWp', true);
                        setFieldTouched('SolarModuleNos', true);
                        setFieldTouched('InverterName', true);
                        setFieldTouched('InverterModuleMake', true);
                        setFieldTouched('InverterModuleWp', true);
                        setFieldTouched('ConsumerNumber', true);
                        setFieldTouched('ConnectionLoad', true);
                        setFieldTouched('Tarrif', true);
                        setFieldTouched('AverageMonthlyBill', true);
                        setFieldTouched('Phase', true);
                        setFieldTouched('Dealer', true);
                        setFieldTouched('CommissionPerKW', true);
                    } else {
                        setFieldTouched('MarketingType', true);
                        setFieldTouched('Date', true);
                        setFieldTouched('payment_as_loan', true);
                        setFieldTouched('type_loan', true);
                        setFieldTouched('WarehouseId', true);
                        setFieldTouched('ConsumerName', true);
                        setFieldTouched('PhoneNumber', true);
                        setFieldTouched('ConsumerNumber', true);
                        setFieldTouched('state', true);
                        setFieldTouched('district', true);
                        setFieldTouched('City_Village', true);
                        setFieldTouched('Address', true);
                        setFieldTouched('Pincode', true);
                        setFieldTouched('Latitude', true);
                        setFieldTouched('Longitude', true);
                        setFieldTouched('ProductName', true);
                        setFieldTouched('SolarModuleMake', true);
                        setFieldTouched('SolarModuleWp', true);
                        setFieldTouched('SolarModuleNos', true);
                        setFieldTouched('SystemSizeKw', true);
                        setFieldTouched('InverterName', true);
                        setFieldTouched('InverterModuleMake', true);
                        setFieldTouched('InverterModuleWp', true);
                        setFieldTouched('PrimaryAmount', true);
                        setFieldTouched('CashAmount', true);
                        setFieldTouched('TotalAmount', true);
                        setFieldTouched('Dealer', true);
                        setFieldTouched('CommissionPerKW', true);
                    }
                }
            });
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStep = (step) => {
        setActiveStep(step);
    };
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const theme = useTheme();


    const handleView = (imageType) => {
        let imageUrl;
        const baseUrl = imgUrl;
        if (imageType.startsWith('MultipleDetails')) {
            const match = imageType.match(/\[(\d+)\]/);
            if (match) {
                const index = parseInt(match[1], 10);
                if (values.dealerImage && values.dealerImage[index]) {
                    imageUrl = values.dealerImage[index] instanceof File
                        ? URL.createObjectURL(values.dealerImage[index])
                        : `${baseUrl}/${values.dealerImage[index]}`;
                } else if (values.MultipleDetails && values.MultipleDetails[index] && values.MultipleDetails[index].dealerImage) {
                    imageUrl = `${baseUrl}/${values.MultipleDetails[index].dealerImage}`;
                }
            }
        }

        if (imageUrl) {
            setViewImage(imageUrl);
            setOpenView(true);
        } else {
            console.error("No image found for the selected type:", imageType);
        }
    }

    const handleAddDetail = () => {
        setInputFields([...inputFields, {
            inputField: '',
            dealerImage: ''
        }])
        setchangeimageMultiple(prev => [...prev, { changed: false, index: inputFields.length }]);
        setFieldValue(`dealerImage.[${inputFields.length}]`, '');
    }


    const { handleSubmit, handleBlur, handleChange, values, touched, errors, setFieldTouched, setFieldValue, setValues, validateForm, setFieldError } = useFormik({
        initialValues: { ...initialValues, MultipleDetails: inputFields },
        validationSchema: getValidationSchema(marketingType, id),
        onSubmit: handleNext,
    });
    const matchedUser = Commmercialdealer?.find(user => user._id === values.userId);




    useEffect(() => {
        setFieldValue('validationSchema', getValidationSchema(marketingType, id));
    }, [marketingType]);


    const steps = values?.MarketingType === 'Commercial' ? commercialSteps : residentialSteps;
    const [stepsWithErrors, setStepsWithErrors] = useState(steps.map(() => false));
    const [touchedSteps, setTouchedSteps] = useState(steps.map(() => false));
    const isLastStep = activeStep === steps.length - 1;



    const [openView, setOpenView] = React.useState(false);
    const [viewImage, setViewImage] = useState(null);

    const handleCloseView = () => {
        setOpenView(false);
    };
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleDownload = async () => {
        if (viewImage) {
            try {
                let imageUrl = viewImage;

                if (imageUrl.includes("4000")) {
                    imageUrl = `/api/proxy-image?url=${encodeURIComponent(viewImage)}`;
                }

                const response = await fetch(imageUrl);

                if (response.ok) {
                    const blob = await response.blob();
                    const fileType = blob.type;

                    if (fileType.startsWith('image/')) {

                        const img = new Image();
                        img.src = URL.createObjectURL(blob);

                        img.onload = () => {
                            const canvas = document.createElement('canvas');
                            const ctx = canvas.getContext('2d');

                            const desiredWidth = 800;
                            const desiredHeight = (img.height / img.width) * desiredWidth;

                            canvas.width = desiredWidth;
                            canvas.height = desiredHeight;

                            ctx.drawImage(img, 0, 0, desiredWidth, desiredHeight);
                            canvas.toBlob((resizedBlob) => {
                                const url = URL.createObjectURL(resizedBlob);
                                const link = document.createElement('a');
                                link.href = url;
                                const fileName = viewImage.split('/').pop();
                                link.download = fileName;

                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                URL.revokeObjectURL(url);
                            }, 'image/jpeg', 0.8);
                        };
                    } else if (fileType === 'application/pdf') {

                        const url = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;

                        const fileName = viewImage.split('/').pop();
                        link.download = fileName;

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                    } else {
                        console.error('Unsupported file type');
                    }
                } else {
                    console.error('Failed to download image or PDF');
                }
            } catch (error) {
                console.error('Error in download process:', error);
            }
        } else {

        }
    };


    const navigate = useNavigate()

    React.useEffect(() => {
        if (touchedSteps.some(touched => touched)) {
            validateForm().then((formErrors) => {
                const newStepsWithErrors = steps.map(() => false);

                Object.keys(formErrors).forEach((errorKey) => {
                    steps.forEach((_, stepIndex) => {
                        if (errorBelongsToStep(errorKey, stepIndex, values.MarketingType)) {
                            newStepsWithErrors[stepIndex] = true;
                        }
                    });
                });

                setStepsWithErrors(newStepsWithErrors);
            });
        }
    }, [values, touchedSteps, values.MarketingType]);


    const [countries, setCountries] = React.useState([]);
    const [states, setStates] = React.useState([]);
    const [districts, setDistricts] = React.useState([]);

    useEffect(() => {
        if (values.country) {
            const countryStates = State.getStatesOfCountry(values.country);
            setStates(countryStates);

            if (values.state) {
                const stateCities = City.getCitiesOfState(values.country, values.state);
                setDistricts(stateCities);
            }
        }
    }, [values.country, values.state]);


    const handleCountryChange = (e) => {
        const countryCode = e.target.value;


        handleChange(e);

        const countryStates = State.getStatesOfCountry(countryCode);
        setStates(countryStates);
        setDistricts([]);
        setFieldValue('state', '');
        setFieldValue('district', '');
    };

    const handleStateChange = (e) => {
        const stateCode = e.target.value;


        handleChange(e);
        const stateCities = City.getCitiesOfState(values.country, stateCode);
        setDistricts(stateCities);
        setFieldValue('district', '');
    };
    const defaultCountry = "India";
    const defaultStates = states.filter(state => state.country === defaultCountry);

    React.useEffect(() => {
        const allCountries = Country.getAllCountries();
        setCountries(allCountries);
    }, []);

    useEffect(() => {
        if (!values.country) {
            setFieldValue('country', 'IN');
            const indianStates = State.getStatesOfCountry('IN');
            setStates(indianStates);
        }
    }, []);

    const DealerRegister = useSelector(state => state.comMarketing.pendingDealer)?.find(u => u._id === dealerset);
    const dealerProduct = useSelector(state => state.comMarketing.dealerProduct)?.find(u => u._id === id);
    const [suggestproduct, setSuggestproduct] = useState({});

    useEffect(() => {
        if (dealerProduct || DealerRegister) {
            const SolarModule = dealerProduct?.solarModuleData?.[0]?.productName || DealerRegister?.solarModuleData?.[0]?.productName;

            const SolarInverter = dealerProduct?.solarInverterData?.[0]?.productName || DealerRegister?.solarInverterData?.[0]?.productName;
            const SystemSize = dealerProduct?.dealerData?.[0]?.SystemSize || DealerRegister?.SystemSize;
            const amount = dealerProduct?.dealerData?.[0]?.amount || DealerRegister?.amount;
            const obj = {
                SolarInverter,
                SolarModule,
                SystemSize,
                amount
            }
            setSuggestproduct(obj);
        }
    }, [DealerRegister]);


    // console.log("values", values);


    return (
        <Box m="2px">
            {id ? (
                <Header
                    title="UPDATE MARKETING DETAILS"
                    subtitle="Update Your Marketing Detail"
                />
            ) : (
                <Header
                    title="ADD MARKETING DETAILS"
                    subtitle="Manage Your Marketing Detail Here"
                />
            )}

            <form onSubmit={handleSubmit}>
                <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>
                    {useMediaQuery("(max-width:425px)") && (
                        <>
                            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                                {steps.slice(0, 3).map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={(props) => (

                                            <ColorlibStepIcon
                                                {...props}
                                                theme={theme}
                                                icon={index + 1}
                                                onClick={() => handleStep(index)}
                                                error={touchedSteps[index] && stepsWithErrors[index]}
                                                marketingType={values.MarketingType}
                                            />


                                        )}>
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                                {steps.slice(3).map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={(props) => (

                                            <ColorlibStepIcon
                                                {...props}
                                                theme={theme}
                                                icon={index + 4}
                                                onClick={() => handleStep(index + 3)}
                                                error={touchedSteps[index + 3] && stepsWithErrors[index + 3]}
                                                marketingType={values.MarketingType}
                                            />


                                        )}>
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </>
                    )}

                    {useMediaQuery("(min-width:426px)") && (
                        <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                            {steps.map((label, index) => (
                                <Step key={label}>
                                    <StepLabel StepIconComponent={(props) => (
                                        <ColorlibStepIcon
                                            {...props}
                                            theme={theme}
                                            icon={index + 1}
                                            onClick={() => handleStep(index)}
                                            error={touchedSteps[index] && stepsWithErrors[index]}
                                            marketingType={values.MarketingType}
                                        />
                                    )}>
                                        {label}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    )}
                    {activeStep === 0 && (
                        <>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 3", width: '100%' },
                                }}
                            >
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120, width: '100%' }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="File No :"
                                        value={values?.fillNo || nextFillNo}
                                        name="fillNo"
                                        sx={{
                                            gridColumn: "span 2",
                                            width: '100%',
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                                <TextField
                                    margin="dense"
                                    id="MarketingType"
                                    name="MarketingType"
                                    label="Marketing Type :"
                                    select
                                    fullWidth
                                    variant="filled"
                                    onChange={(e) => {
                                        handleChange(e);
                                        setMarketingType(e.target.value);
                                    }}
                                    onBlur={handleBlur}
                                    value={values?.MarketingType}
                                    error={touched.MarketingType && Boolean(errors.MarketingType)}
                                    helperText={touched.MarketingType && errors.MarketingType}
                                    disabled={DealerRegister?.MarketingType ? true : false} // Add this line to disable when MarketingType comes from dealerset
                                    InputLabelProps={{
                                        style: {
                                            color: theme.palette.text.primary

                                        }
                                    }}
                                    sx={{ width: '100%', marginLeft: '8px' }}
                                >
                                    <MenuItem value="Commercial">Commercial</MenuItem>
                                    <MenuItem value="Residential">Residential</MenuItem>
                                </TextField>
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120, width: '100%' }}>
                                    <TextField
                                        id="Date"
                                        label="Date :"
                                        type="date"
                                        variant="filled"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.Date}
                                        name="Date"
                                        error={!!touched.Date && !!errors.Date}
                                        helperText={touched.Date && errors.Date}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                        sx={{ width: '100%' }}
                                    />
                                </FormControl>
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Recd Payment As a loan"
                                        name="payment_as_loan"
                                        value={values.payment_as_loan}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>

                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Loan Type"
                                        name="type_loan"
                                        value={values.type_loan}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>

                            </Box>
                        </>
                    )}

                    {marketingType === 'Commercial' && (
                        <>
                            {activeStep === 1 && (
                                <>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >

                                        <FormControl variant="filled" sx={{ mx: 1, minWidth: 120 }}>
                                            <TextField
                                                margin="dense"
                                                id="warehouse"
                                                name="warehouse"
                                                label="Warehouse :"
                                                select
                                                fullWidth
                                                variant="filled"
                                                onChange={(event) => {
                                                    handleChange(event);
                                                    setFieldValue('WarehouseId', event.target.value);
                                                }}
                                                onBlur={handleBlur}
                                                value={values?.WarehouseId}
                                                error={touched.WarehouseId && Boolean(errors.WarehouseId)}
                                                helperText={touched.WarehouseId && errors.WarehouseId}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                sx={{ width: '100%' }}
                                            >
                                                {Warehouse?.map((warehouse) => (
                                                    <MenuItem key={warehouse._id} value={warehouse._id}>
                                                        {warehouse.wareHouseName}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Consumer Name as per Light bill :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                        handleChange(e);
                                                    
                                                }}
                                                value={values.ConsumerName}
                                                name="ConsumerName"
                                                error={!!ConsumerNameError || (touched.ConsumerName && !!errors.ConsumerName)}
                                                helperText={ConsumerNameError || (touched.ConsumerName && errors.ConsumerName)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>

                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Contact Person Name : "
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    
                                                        handleChange(e);
                                                       
                                                }}
                                                value={values.ContactPersonName}
                                                name="ContactPersonName"
                                                error={!!ContactPersonNameError || (touched.ContactPersonName && !!errors.ContactPersonName)}
                                                helperText={ContactPersonNameError || (touched.ContactPersonName && errors.ContactPersonName)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />

                                        </FormControl>
                                    </Box>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 2" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Phone Number : "
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d{0,10}$/.test(value)) {
                                                        handleChange(e);
                                                        setPhoneError('');
                                                    } else {
                                                        setPhoneError('Phone Number must be exactly 10 digits');
                                                    }
                                                }}
                                                value={values.PhoneNumber}
                                                name="PhoneNumber"
                                                error={!!PhoneError || (touched.PhoneNumber && !!errors.PhoneNumber)}
                                                helperText={PhoneError || (touched.PhoneNumber && errors.PhoneNumber)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                select
                                                fullWidth
                                                variant="filled"
                                                label="State :"
                                                onBlur={handleBlur}
                                                onChange={handleStateChange}
                                                value={values.state}
                                                name="state"
                                                error={!!touched.state && !!errors.state}
                                                helperText={touched.state && errors.state}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                SelectProps={{
                                                    MenuProps: {
                                                        anchorOrigin: {
                                                            vertical: 'bottom',
                                                            horizontal: 'left',
                                                        },
                                                        transformOrigin: {
                                                            vertical: 'top',
                                                            horizontal: 'left',
                                                        },
                                                        PaperProps: {
                                                            style: {
                                                                maxHeight: 300,
                                                            },
                                                        },
                                                    },
                                                }}
                                            >
                                                {states.map((state) => (
                                                    <MenuItem key={state.isoCode} value={state.isoCode}>
                                                        {state.name}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                select
                                                fullWidth
                                                variant="filled"
                                                label="District :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.district}
                                                name="district"
                                                error={!!touched.district && !!errors.district}
                                                helperText={touched.district && errors.district}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                SelectProps={{
                                                    MenuProps: {
                                                        anchorOrigin: {
                                                            vertical: 'bottom',
                                                            horizontal: 'left',
                                                        },
                                                        transformOrigin: {
                                                            vertical: 'top',
                                                            horizontal: 'left',
                                                        },
                                                        PaperProps: {
                                                            style: {
                                                                maxHeight: 300,
                                                            },
                                                        },
                                                    },
                                                }}
                                            >
                                                {districts.map((district) => (
                                                    <MenuItem key={district.name} value={district.name}>
                                                        {district.name}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </FormControl>

                                    </Box>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                id="Address"
                                                label="Address :"
                                                multiline
                                                defaultValue=""
                                                variant="filled"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.Address}
                                                name="Address"
                                                error={!!AddressError || (touched.Address && !!errors.Address)}
                                                helperText={AddressError || (touched.Address && errors.Address)}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                id="City_Village"
                                                label="City/Village :"
                                                multiline
                                                defaultValue=""
                                                variant="filled"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^[a-zA-Z\s]*$/.test(value)) {
                                                        handleChange(e);
                                                        setCityVillageError('');
                                                    } else {
                                                        setCityVillageError('City/Village can only contain letters');
                                                    }
                                                }}
                                                value={values.City_Village}
                                                name="City_Village"
                                                error={!!CityVillageError || (touched.City_Village && !!errors.City_Village)}
                                                helperText={CityVillageError || (touched.City_Village && errors.City_Village)}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                id="Pincode"
                                                label="Pincode :"
                                                multiline
                                                defaultValue=""
                                                variant="filled"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d{0,6}$/.test(value)) {
                                                        handleChange(e);
                                                        setPincodeError('');
                                                    } else {
                                                        setPincodeError('Pincode contain only numbers and must be exactly 6 digits');
                                                    }
                                                }}
                                                value={values.Pincode}
                                                name="Pincode"
                                                error={!!PincodeError || (touched.Pincode && !!errors.Pincode)}
                                                helperText={PincodeError || (touched.Pincode && errors.Pincode)}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </Box>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >

                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                id="Latitude"
                                                label="Latitude :"
                                                multiline
                                                defaultValue=""
                                                variant="filled"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setLatitudeError('');
                                                    } else {
                                                        setLatitudeError('Latitude can only contain numbers');
                                                    }
                                                }}
                                                value={values.Latitude}
                                                name="Latitude"
                                                error={!!LatitudeError || (touched.Latitude && !!errors.Latitude)}
                                                helperText={LatitudeError || (touched.Latitude && errors.Latitude)}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                id="Longitude"
                                                label="Longitude :"
                                                multiline
                                                defaultValue=""
                                                variant="filled"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setLongitudeError('');
                                                    } else {
                                                        setLongitudeError('Longitude can only contain numbers');
                                                    }
                                                }}
                                                value={values.Longitude}
                                                name="Longitude"
                                                error={!!LongitudeError || (touched.Longitude && !!errors.Longitude)}
                                                helperText={LongitudeError || (touched.Longitude && errors.Longitude)}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>

                                    </Box>

                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        {inputFields && inputFields.length > 0 && inputFields.map((field, index) => (
                                            <React.Fragment key={index}>
                                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        name={`MultipleDetails[${index}].inputField`}
                                                        label={`Input Field ${index + 1} :`}
                                                        type="text"
                                                        fullWidth
                                                        variant="filled"
                                                        onChange={(e) => {
                                                            const newFields = [...inputFields];
                                                            newFields[index].inputField = e.target.value;
                                                            setInputFields(newFields);
                                                            setFieldValue(`MultipleDetails[${index}].inputField`, e.target.value);
                                                        }}
                                                        value={values.MultipleDetails?.[index]?.inputField}
                                                        error={touched.MultipleDetails?.[index]?.inputField && Boolean(errors.MultipleDetails?.[index]?.inputField)}
                                                        helperText={touched.MultipleDetails?.[index]?.inputField && errors.MultipleDetails?.[index]?.inputField}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                                    <Button variant="contained" component="label">
                                                        Upload
                                                        <input
                                                            type="file"
                                                            hidden
                                                            name={`MultipleDetails[${index}].dealerImage`}
                                                            onChange={e => {
                                                                const files = Array.from(e.target.files);
                                                                setFieldValue(`dealerImage.[${index}]`, files[0]);
                                                                setchangeimageMultiple(prev => prev.map((item, idx) =>
                                                                    idx == index ? { ...item, changed: true } : item
                                                                ));
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                    </Button>
                                                    {changeimageMultiple[index]?.changed ? (
                                                        values.dealerImage?.[index] && (
                                                            values.dealerImage[index] instanceof File ? (
                                                                values.dealerImage[index].name.toLowerCase().endsWith('.pdf') ? (
                                                                    <iframe
                                                                        src={URL.createObjectURL(values.dealerImage[index])}
                                                                        style={{ width: '50px', height: '50px', border: 'none' }}
                                                                        title="PDF Preview"
                                                                    />
                                                                ) : (

                                                                    <img
                                                                        src={URL.createObjectURL(values.dealerImage[index])}
                                                                        alt="avatar"
                                                                        width="50"
                                                                        height="50"
                                                                        style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                                    />
                                                                )
                                                            ) : (

                                                                <img
                                                                    src={`${imgUrl}/${values.dealerImage[index]}`}
                                                                    alt="avatar"
                                                                    width="50"
                                                                    height="50"
                                                                    style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                                />
                                                            )
                                                        )
                                                    ) : (
                                                        values.MultipleDetails?.[index]?.dealerImage && (
                                                            typeof values.MultipleDetails[index].dealerImage === 'string' && values.MultipleDetails[index].dealerImage.toLowerCase().endsWith('.pdf') ? (
                                                                <iframe
                                                                    src={`${imgUrl}/${values.MultipleDetails[index].dealerImage}`}
                                                                    style={{ width: '50px', height: '50px', border: 'none' }}
                                                                    title="PDF Preview"
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={`${imgUrl}/${values.MultipleDetails[index].dealerImage}`}
                                                                    alt="avatar"
                                                                    width="50"
                                                                    height="50"
                                                                    style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                                />
                                                            )
                                                        )
                                                    )}
                                                    <IconButton aria-label="edit" onClick={() => handleView(`MultipleDetails[${index}].dealerImage`)}>
                                                        <RemoveRedEyeIcon />
                                                    </IconButton>
                                                </div>
                                            </React.Fragment>
                                        ))}
                                    </Box>

                                    <Box display="flex" justifyContent="flex-end" m={1}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<AddIcon />}
                                            onClick={handleAddDetail}
                                        >
                                            Add Detail
                                        </Button>
                                    </Box>

                                </>
                            )}
                            {activeStep === 2 && (
                                <>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Amount :"
                                                onBlur={handleBlur}

                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setAmountError('');
                                                    } else {
                                                        setAmountError('Amount can only contain numbers');
                                                    }
                                                }}
                                                value={values.Amount}
                                                name="Amount"
                                                error={!!AmountError || (touched.Amount && !!errors.Amount)}
                                                helperText={AmountError || (touched.Amount && errors.Amount)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="GST :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setGSTError('');
                                                    } else {
                                                        setGSTError('GST can only contain numbers');
                                                    }
                                                }}
                                                value={values.GST}
                                                name="GST"
                                                error={!!GSTError || (touched.GST && !!errors.GST)}
                                                helperText={GSTError || (touched.GST && errors.GST)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Total Amount :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={parseFloat(values.Amount || 0) + parseFloat(values.GST || 0)}
                                                name="TotalAmount"
                                                error={!!TotalAmountError || (touched.TotalAmount && !!errors.TotalAmount)}
                                                helperText={TotalAmountError || (touched.TotalAmount && errors.TotalAmount)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                            <Typography sx={{ mt: 1 }}> {suggestproduct && suggestproduct.amount ? `Suggested : ${suggestproduct?.amount}`
                                                : " "}</Typography>

                                        </FormControl>
                                    </Box>
                                </>
                            )}
                            {activeStep === 3 && (
                                <>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="GST Number :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.GSTNumber}
                                                name="GSTNumber"
                                                error={!!GSTNumberError || (touched.GSTNumber && !!errors.GSTNumber)}
                                                helperText={GSTNumberError || (touched.GSTNumber && errors.GSTNumber)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Pan Number:"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.PanNumber}
                                                name="PanNumber"
                                                error={!!PanNumberError || (touched.PanNumber && !!errors.PanNumber)}
                                                helperText={PanNumberError || (touched.PanNumber && errors.PanNumber)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="MSME/udyam REGISTRATION :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.MSME_UdyamREGISTRATION}
                                                name="MSME_UdyamREGISTRATION"
                                                error={!!MSMEUdyamREGISTRATIONError || (touched.MSME_UdyamREGISTRATION && !!errors.MSME_UdyamREGISTRATION)}
                                                helperText={MSMEUdyamREGISTRATIONError || (touched.MSME_UdyamREGISTRATION && errors.MSME_UdyamREGISTRATION)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </Box>

                                </>
                            )}
                            {activeStep === 4 && (
                                <>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                select
                                                variant="filled"
                                                label="Solar Module : "
                                                onBlur={handleBlur}
                                                onChange={(event) => {
                                                    const selectedProductId = event.target.value;
                                                    const selectedProduct = product.find(product => product._id === selectedProductId);

                                                    handleChange(event);
                                                    if (selectedProduct) {
                                                        setFieldValue('SolarModuleMake', selectedProduct.make);
                                                        setFieldValue('SolarModuleWp', selectedProduct.Size);
                                                        const newSizeKw = selectedProduct.Size * values.SolarModuleNos / 1000;
                                                        setFieldValue('SystemSizeKw', newSizeKw);
                                                    }
                                                }}
                                                value={values.ProductName}
                                                name="ProductName"
                                                error={!!touched.ProductName && !!errors.ProductName}
                                                helperText={touched.ProductName && errors.ProductName}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            >
                                                {product?.filter(v => v.mainCategoryData?.[0]?.categoryName === "Solar PV Module")?.map((v) => (
                                                    <MenuItem key={v._id} value={v._id}>{v.productName}</MenuItem>
                                                ))}
                                            </TextField>
                                            <Typography sx={{ mt: 1 }}>Suggested : {suggestproduct?.SolarModule}</Typography>
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Solar Module Make :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.SolarModuleMake}
                                                name="SolarModuleMake"
                                                error={!!touched.SolarModuleMake && !!errors.SolarModuleMake}
                                                helperText={touched.SolarModuleMake && errors.SolarModuleMake}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    shrink: !!values.SolarModuleMake,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Solar Module Wp :"
                                                onBlur={handleBlur}
                                                onChange={(event) => {
                                                    handleChange(event);
                                                    const newWp = event.target.value;
                                                    const newSizeKw = newWp * values.SolarModuleNos;
                                                    setFieldValue('SystemSizeKw', newSizeKw);
                                                }}
                                                value={values.SolarModuleWp}
                                                name="SolarModuleWp"
                                                error={!!touched.SolarModuleWp && !!errors.SolarModuleWp}
                                                helperText={touched.SolarModuleWp && errors.SolarModuleWp}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    shrink: !!values.SolarModuleWp,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Solar Module Nos :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        const newNos = value;
                                                        const newSizeKw = values.SolarModuleWp * newNos / 1000;
                                                        setFieldValue('SystemSizeKw', newSizeKw);
                                                        setError('');
                                                    } else {
                                                        setError('Solar Module Nos can only contain numbers');
                                                    }
                                                }}
                                                value={values.SolarModuleNos}
                                                name="SolarModuleNos"
                                                error={!!Error || (touched.SolarModuleNos && !!errors.SolarModuleNos)}
                                                helperText={Error || (touched.SolarModuleNos && errors.SolarModuleNos)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </Box>

                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                select
                                                variant="filled"
                                                label="Solar Inverter : "
                                                onBlur={handleBlur}
                                                onChange={(event) => {
                                                    const selectedInverterId = event.target.value;
                                                    const selectedInverter = product.find(product => product._id === selectedInverterId);
                                                    handleChange(event);
                                                    if (selectedInverter) {
                                                        setFieldValue('InverterModuleMake', selectedInverter.make);
                                                        setFieldValue('InverterModuleWp', selectedInverter.Size);
                                                    }
                                                }}
                                                value={values.InverterName}
                                                name="InverterName"
                                                error={!!touched.InverterName && !!errors.InverterName}
                                                helperText={touched.InverterName && errors.InverterName}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            >
                                                {product?.filter(v => v.mainCategoryData?.[0]?.categoryName === "Solar Grid Tie Inverter")?.map((v) => (
                                                    <MenuItem key={v._id} value={v._id}>{v.productName}</MenuItem>
                                                ))}
                                            </TextField>
                                            <Typography sx={{ mt: 1 }}>Suggested : {suggestproduct?.SolarInverter}</Typography>
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Solar Inverter Make :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.InverterModuleMake}
                                                name="InverterModuleMake"
                                                error={!!touched.InverterModuleMake && !!errors.InverterModuleMake}
                                                helperText={touched.InverterModuleMake && errors.InverterModuleMake}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    shrink: !!values.InverterModuleMake,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Solar Inverter Size :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.InverterModuleWp}
                                                name="InverterModuleWp"
                                                error={!!touched.InverterModuleWp && !!errors.InverterModuleWp}
                                                helperText={touched.InverterModuleWp && errors.InverterModuleWp}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    shrink: !!values.InverterModuleWp,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </FormControl>
                                    </Box>

                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="System Size :"
                                                value={values.SystemSizeKw || 0}
                                                name="SystemSizeKw"
                                                error={!!touched.SystemSizeKw && !!errors.SystemSizeKw}
                                                helperText={touched.SystemSizeKw && errors.SystemSizeKw}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                            <Typography sx={{ mt: 1 }}>Suggested : {suggestproduct?.SystemSize}</Typography>
                                        </FormControl>
                                    </Box>
                                </>
                            )}
                            {activeStep === 5 && (
                                <>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Consumer Number :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setConsumerNumberError('');
                                                    } else {
                                                        setConsumerNumberError('Consumer Number can only contain numbers');
                                                    }
                                                }}
                                                value={values.ConsumerNumber}
                                                name="ConsumerNumber"
                                                error={!!ConsumerNumberError || (touched.ConsumerNumber && !!errors.ConsumerNumber)}
                                                helperText={ConsumerNumberError || (touched.ConsumerNumber && errors.ConsumerNumber)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Connection Load :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setConnectionLoadError('');
                                                    } else {
                                                        setConnectionLoadError('Connection Load can only contain numbers');
                                                    }
                                                }}
                                                value={values.ConnectionLoad}
                                                name="ConnectionLoad"
                                                error={!!ConnectionLoadError || (touched.ConnectionLoad && !!errors.ConnectionLoad)}
                                                helperText={ConnectionLoadError || (touched.ConnectionLoad && errors.ConnectionLoad)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </Box>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Tarrif :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    handleChange(e);
                                                    // if (/^\d*\.?\d*$/.test(value)) {
                                                    //     handleChange(e);
                                                    //     setTarrifError('');
                                                    // } else {
                                                    //     setTarrifError('Tarrif can only contain numbers');
                                                    // }
                                                }}
                                                value={values.Tarrif}
                                                name="Tarrif"
                                                error={!!TarrifError || (touched.Tarrif && !!errors.Tarrif)}
                                                helperText={TarrifError || (touched.Tarrif && errors.Tarrif)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Average Monthly Bill :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setAverageMonthlyBillError('');
                                                    } else {
                                                        setAverageMonthlyBillError('Average Monthly Bill can only contain numbers');
                                                    }
                                                }}
                                                value={values.AverageMonthlyBill}
                                                name="AverageMonthlyBill"
                                                error={!!AverageMonthlyBillError || (touched.AverageMonthlyBill && !!errors.AverageMonthlyBill)}
                                                helperText={AverageMonthlyBillError || (touched.AverageMonthlyBill && errors.AverageMonthlyBill)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <FormLabel id="demo-row-radio-buttons-group-label" sx={{
                                                color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000',
                                                '&.Mui-focused': {
                                                    color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000',
                                                },
                                            }}>Phase :</FormLabel>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="Phase"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.Phase}
                                            >
                                                <FormControlLabel value="1" control={<Radio
                                                    sx={{
                                                        color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000',
                                                        '&.Mui-checked': {
                                                            color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000',
                                                        },
                                                    }}
                                                />} label="1" />
                                                <FormControlLabel value="3" control={<Radio
                                                    sx={{
                                                        color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000',
                                                        '&.Mui-checked': {
                                                            color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000',
                                                        },
                                                    }}
                                                />} label="3" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Box>
                                </>
                            )}
                            {activeStep === 6 && (
                                <>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            {values?.userId ? (
                                                <TextField
                                                    margin="dense"
                                                    id="userId"
                                                    name="userId"
                                                    label="Dealer :"
                                                    fullWidth
                                                    variant="filled"
                                                    value={matchedUser?.name || dealerName || ''}
                                                    InputProps={{
                                                        readOnly: true
                                                    }}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                />
                                            ) : (
                                                <TextField
                                                    select
                                                    margin="dense"
                                                    id="userId"
                                                    name="userId"
                                                    label="Dealer :"
                                                    fullWidth
                                                    variant="filled"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.userId || dealerName || ''}
                                                    error={touched.userId && Boolean(errors.userId)}
                                                    helperText={touched.userId && errors.userId}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                >
                                                    {Commmercialdealer.map((dealer) => (
                                                        <MenuItem key={dealer._id} value={dealer._id}>
                                                            {dealer.name}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            )}
                                        </FormControl>
                                    </Box>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="System Size :"
                                                value={values.SystemSizeKw || 0}
                                                name="SystemSizeKw"
                                                error={!!touched.SystemSizeKw && !!errors.SystemSizeKw}
                                                helperText={touched.SystemSizeKw && errors.SystemSizeKw}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Commission/PerKW:"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setCommissionPerKWError('');
                                                    } else {
                                                        setCommissionPerKWError('Commission/PerKW can only contain numbers');
                                                    }
                                                }}
                                                value={values.CommissionPerKW}
                                                name="CommissionPerKW"
                                                error={!!CommissionPerKWError || (touched.CommissionPerKW && !!errors.CommissionPerKW)}
                                                helperText={CommissionPerKWError || (touched.CommissionPerKW && errors.CommissionPerKW)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Total Commission:"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={(values.SystemSizeKw * values.CommissionPerKW).toFixed(2) === 'NaN' ? '0' : (values.SystemSizeKw * values.CommissionPerKW).toFixed(2)}
                                                name="TotalCommission"
                                                error={!!touched.TotalCommission && !!errors.TotalCommission}
                                                helperText={touched.TotalCommission && errors.TotalCommission}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </Box>

                                </>
                            )}
                        </>
                    )}

                    {marketingType === 'Residential' && (
                        <>
                            {activeStep === 1 && (
                                <>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ mx: 1, minWidth: 120 }}>
                                            <TextField
                                                margin="dense"
                                                id="warehouse"
                                                name="warehouse"
                                                label="Warehouse :"
                                                select
                                                fullWidth
                                                variant="filled"
                                                onChange={(event) => {
                                                    handleChange(event);
                                                    setFieldValue('WarehouseId', event.target.value);
                                                }}
                                                onBlur={handleBlur}
                                                value={values?.WarehouseId}
                                                error={touched.WarehouseId && Boolean(errors.WarehouseId)}
                                                helperText={touched.WarehouseId && errors.WarehouseId}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                sx={{ width: '100%' }}
                                            >
                                                {Warehouse?.map((warehouse) => (
                                                    <MenuItem key={warehouse._id} value={warehouse._id}>
                                                        {warehouse.wareHouseName}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>

                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Consumer Name :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    
                                                        handleChange(e);
                                                        
                                                }}
                                                value={values.ConsumerName}
                                                name="ConsumerName"
                                                error={!!ConsumerNameError || (touched.ConsumerName && !!errors.ConsumerName)}
                                                helperText={ConsumerNameError || (touched.ConsumerName && errors.ConsumerName)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Phone Number : "
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d{0,10}$/.test(value)) {
                                                        handleChange(e);
                                                        setPhoneError('');
                                                    } else {
                                                        setPhoneError('Phone Number must be exactly 10 digits');
                                                    }
                                                }}
                                                value={values.PhoneNumber}
                                                name="PhoneNumber"
                                                error={!!PhoneError || (touched.PhoneNumber && !!errors.PhoneNumber)}
                                                helperText={PhoneError || (touched.PhoneNumber && errors.PhoneNumber)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />

                                        </FormControl>

                                    </Box>

                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 2" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Consumer Number : "
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setConsumerNumberError('');
                                                    } else {
                                                        setConsumerNumberError('Consumer Number can only contain numbers');
                                                    }
                                                }}
                                                value={values.ConsumerNumber}
                                                name="ConsumerNumber"
                                                error={!!ConsumerNumberError || (touched.ConsumerNumber && !!errors.ConsumerNumber)}
                                                helperText={ConsumerNumberError || (touched.ConsumerNumber && errors.ConsumerNumber)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                select
                                                fullWidth
                                                variant="filled"
                                                label="State :"
                                                onBlur={handleBlur}
                                                onChange={handleStateChange}
                                                value={values.state}
                                                name="state"
                                                error={!!touched.state && !!errors.state}
                                                helperText={touched.state && errors.state}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                SelectProps={{
                                                    MenuProps: {
                                                        anchorOrigin: {
                                                            vertical: 'bottom',
                                                            horizontal: 'left',
                                                        },
                                                        transformOrigin: {
                                                            vertical: 'top',
                                                            horizontal: 'left',
                                                        },
                                                        PaperProps: {
                                                            style: {
                                                                maxHeight: 300,
                                                            },
                                                        },
                                                    },
                                                }}
                                            >
                                                {states.map((state) => (
                                                    <MenuItem key={state.isoCode} value={state.isoCode}>
                                                        {state.name}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                select
                                                fullWidth
                                                variant="filled"
                                                label="District :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.district}
                                                name="district"
                                                error={!!touched.district && !!errors.district}
                                                helperText={touched.district && errors.district}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                SelectProps={{
                                                    MenuProps: {
                                                        anchorOrigin: {
                                                            vertical: 'bottom',
                                                            horizontal: 'left',
                                                        },
                                                        transformOrigin: {
                                                            vertical: 'top',
                                                            horizontal: 'left',
                                                        },
                                                        PaperProps: {
                                                            style: {
                                                                maxHeight: 300,
                                                            },
                                                        },
                                                    },
                                                }}
                                            >
                                                {districts.map((district) => (
                                                    <MenuItem key={district.name} value={district.name}>
                                                        {district.name}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </FormControl>
                                    </Box>

                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                id="City_Village"
                                                label="City/Village :"
                                                multiline
                                                defaultValue=""
                                                variant="filled"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^[a-zA-Z\s]*$/.test(value)) {
                                                        handleChange(e);
                                                        setCityVillageError('');
                                                    } else {
                                                        setCityVillageError('City/Village can only contain letters');
                                                    }
                                                }}
                                                value={values.City_Village}
                                                name="City_Village"
                                                error={!!CityVillageError || (touched.City_Village && !!errors.City_Village)}
                                                helperText={CityVillageError || (touched.City_Village && errors.City_Village)}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                id="Address"
                                                label="Address :"
                                                multiline
                                                defaultValue=""
                                                variant="filled"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.Address}
                                                name="Address"
                                                error={!!AddressError || (touched.Address && !!errors.Address)}
                                                helperText={AddressError || (touched.Address && errors.Address)}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                id="Pincode"
                                                label="Pincode :"
                                                multiline
                                                defaultValue=""
                                                variant="filled"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d{0,6}$/.test(value)) {
                                                        handleChange(e);
                                                        setPincodeError('');
                                                    } else {
                                                        setPincodeError('Pincode must be exactly 6 digits');
                                                    }
                                                }}
                                                value={values.Pincode}
                                                name="Pincode"
                                                error={!!PincodeError || (touched.Pincode && !!errors.Pincode)}
                                                helperText={PincodeError || (touched.Pincode && errors.Pincode)}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </Box>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                id="Latitude"
                                                label="Latitude :"
                                                multiline
                                                defaultValue=""
                                                variant="filled"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setLatitudeError('');
                                                    } else {
                                                        setLatitudeError('Latitude can only contain numbers');
                                                    }
                                                }}
                                                value={values.Latitude}
                                                name="Latitude"
                                                error={!!LatitudeError || (touched.Latitude && !!errors.Latitude)}
                                                helperText={LatitudeError || (touched.Latitude && errors.Latitude)}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                id="Longitude"
                                                label="Longitude :"
                                                multiline
                                                defaultValue=""
                                                variant="filled"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setLongitudeError('');
                                                    } else {
                                                        setLongitudeError('Longitude can only contain numbers');
                                                    }
                                                }}
                                                value={values.Longitude}
                                                name="Longitude"
                                                error={!!LongitudeError || (touched.Longitude && !!errors.Longitude)}
                                                helperText={LongitudeError || (touched.Longitude && errors.Longitude)}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </Box>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        {inputFields && inputFields.length > 0 && inputFields.map((field, index) => (
                                            <React.Fragment key={index}>
                                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        name={`MultipleDetails[${index}].inputField`}
                                                        label={`Input Field ${index + 1} :`}
                                                        type="text"
                                                        fullWidth
                                                        variant="filled"
                                                        onChange={(e) => {
                                                            const newFields = [...inputFields];
                                                            newFields[index].inputField = e.target.value;
                                                            setInputFields(newFields);
                                                            setFieldValue(`MultipleDetails[${index}].inputField`, e.target.value);
                                                        }}
                                                        value={values.MultipleDetails?.[index]?.inputField}
                                                        error={touched.MultipleDetails?.[index]?.inputField && Boolean(errors.MultipleDetails?.[index]?.inputField)}
                                                        helperText={touched.MultipleDetails?.[index]?.inputField && errors.MultipleDetails?.[index]?.inputField}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                                    <Button variant="contained" component="label">
                                                        Upload
                                                        <input
                                                            type="file"
                                                            hidden
                                                            name={`MultipleDetails[${index}].dealerImage`}
                                                            onChange={e => {
                                                                const files = Array.from(e.target.files);
                                                                setFieldValue(`dealerImage.[${index}]`, files[0]);
                                                                setchangeimageMultiple(prev => prev.map((item, idx) =>
                                                                    idx == index ? { ...item, changed: true } : item
                                                                ));
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                    </Button>

                                                    {changeimageMultiple[index]?.changed ? (
                                                        values.dealerImage?.[index] && (
                                                            values.dealerImage[index] instanceof File ? (
                                                                values.dealerImage[index].name.toLowerCase().endsWith('.pdf') ? (
                                                                    <iframe
                                                                        src={URL.createObjectURL(values.dealerImage[index])}
                                                                        style={{ width: '50px', height: '50px', border: 'none' }}
                                                                        title="PDF Preview"
                                                                    />
                                                                ) : (

                                                                    <img
                                                                        src={URL.createObjectURL(values.dealerImage[index])}
                                                                        alt="avatar"
                                                                        width="50"
                                                                        height="50"
                                                                        style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                                    />
                                                                )
                                                            ) : (

                                                                <img
                                                                    src={`${imgUrl}/${values.dealerImage[index]}`}
                                                                    alt="avatar"
                                                                    width="50"
                                                                    height="50"
                                                                    style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                                />
                                                            )
                                                        )
                                                    ) : (
                                                        values.MultipleDetails?.[index]?.dealerImage && (
                                                            typeof values.MultipleDetails[index].dealerImage === 'string' && values.MultipleDetails[index].dealerImage.toLowerCase().endsWith('.pdf') ? (
                                                                <iframe
                                                                    src={`${imgUrl}/${values.MultipleDetails[index].dealerImage}`}
                                                                    style={{ width: '50px', height: '50px', border: 'none' }}
                                                                    title="PDF Preview"
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={`${imgUrl}/${values.MultipleDetails[index].dealerImage}`}
                                                                    alt="avatar"
                                                                    width="50"
                                                                    height="50"
                                                                    style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                                />
                                                            )
                                                        )
                                                    )}
                                                    <IconButton aria-label="edit" onClick={() => handleView(`MultipleDetails[${index}].dealerImage`)}>
                                                        <RemoveRedEyeIcon />
                                                    </IconButton>
                                                </div>
                                            </React.Fragment>
                                        ))}
                                    </Box>

                                    <Box display="flex" justifyContent="flex-end" m={1}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<AddIcon />}
                                            onClick={handleAddDetail}
                                        >
                                            Add Detail
                                        </Button>
                                    </Box>
                                </>
                            )}
                            {activeStep === 2 && (
                                <>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                select
                                                variant="filled"
                                                label="Solar Module : "
                                                onBlur={handleBlur}
                                                onChange={(event) => {
                                                    const selectedProductId = event.target.value;
                                                    const selectedProduct = product.find(product => product._id === selectedProductId);
                                                    handleChange(event);
                                                    if (selectedProduct) {
                                                        setFieldValue('SolarModuleMake', selectedProduct.make);
                                                        setFieldValue('SolarModuleWp', selectedProduct.Size);
                                                        const newSizeKw = selectedProduct.Size * values.SolarModuleNos / 1000;
                                                        setFieldValue('SystemSizeKw', newSizeKw);
                                                    }
                                                }}
                                                value={values.ProductName}
                                                name="ProductName"
                                                error={!!touched.ProductName && !!errors.ProductName}
                                                helperText={touched.ProductName && errors.ProductName}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            >
                                                {product?.filter(v => v.mainCategoryData?.[0]?.categoryName === "Solar PV Module")?.map((v) => (
                                                    <MenuItem key={v._id} value={v._id}>{v.productName}</MenuItem>
                                                ))}
                                            </TextField>
                                            <Typography sx={{ mt: 1 }}>Suggested : {suggestproduct?.SolarModule}</Typography>
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Solar Module Make :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.SolarModuleMake}
                                                name="SolarModuleMake"
                                                error={!!touched.SolarModuleMake && !!errors.SolarModuleMake}
                                                helperText={touched.SolarModuleMake && errors.SolarModuleMake}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    shrink: !!values.SolarModuleMake,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Solar Module Wp :"
                                                onBlur={handleBlur}
                                                onChange={(event) => {
                                                    handleChange(event);
                                                    const newWp = event.target.value;
                                                    const newSizeKw = newWp * values.SolarModuleNos;
                                                    setFieldValue('SystemSizeKw', newSizeKw);
                                                }}
                                                value={values.SolarModuleWp}
                                                name="SolarModuleWp"
                                                error={!!touched.SolarModuleWp && !!errors.SolarModuleWp}
                                                helperText={touched.SolarModuleWp && errors.SolarModuleWp}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    shrink: !!values.SolarModuleWp,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </FormControl>

                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Solar Module Nos :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        const newNos = value;
                                                        const newSizeKw = values.SolarModuleWp * newNos / 1000;
                                                        setFieldValue('SystemSizeKw', newSizeKw);
                                                        setError('');
                                                    } else {
                                                        setError('Solar Module Nos can only contain numbers');
                                                    }
                                                }}
                                                value={values.SolarModuleNos}
                                                name="SolarModuleNos"
                                                error={!!Error || (touched.SolarModuleNos && !!errors.SolarModuleNos)}
                                                helperText={Error || (touched.SolarModuleNos && errors.SolarModuleNos)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </Box>

                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                select
                                                variant="filled"
                                                label="Solar Inverter : "
                                                onBlur={handleBlur}
                                                onChange={(event) => {
                                                    const selectedInverterId = event.target.value;
                                                    const selectedInverter = product.find(product => product._id === selectedInverterId);
                                                    handleChange(event);
                                                    if (selectedInverter) {
                                                        setFieldValue('InverterModuleMake', selectedInverter.make);
                                                        setFieldValue('InverterModuleWp', selectedInverter.Size);
                                                    }
                                                }}
                                                value={values.InverterName}
                                                name="InverterName"
                                                error={!!touched.InverterName && !!errors.InverterName}
                                                helperText={touched.InverterName && errors.InverterName}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            >
                                                {product?.filter(v => v.mainCategoryData?.[0]?.categoryName === "Solar Grid Tie Inverter")?.map((v) => (
                                                    <MenuItem key={v._id} value={v._id}>{v.productName}</MenuItem>
                                                ))}
                                            </TextField>
                                            <Typography sx={{ mt: 1 }}>Suggested : {suggestproduct?.SolarInverter}</Typography>
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Solar Inverter Make :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.InverterModuleMake}
                                                name="InverterModuleMake"
                                                error={!!touched.InverterModuleMake && !!errors.InverterModuleMake}
                                                helperText={touched.InverterModuleMake && errors.InverterModuleMake}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    shrink: !!values.InverterModuleMake,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Solar Inverter Size :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.InverterModuleWp}
                                                name="InverterModuleWp"
                                                error={!!touched.InverterModuleWp && !!errors.InverterModuleWp}
                                                helperText={touched.InverterModuleWp && errors.InverterModuleWp}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    shrink: !!values.InverterModuleWp,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </FormControl>
                                    </Box>

                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="System Size :"
                                                value={values.SystemSizeKw || 0}
                                                name="SystemSizeKw"
                                                error={!!touched.SystemSizeKw && !!errors.SystemSizeKw}
                                                helperText={touched.SystemSizeKw && errors.SystemSizeKw}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                            <Typography sx={{ mt: 1 }}>Suggested : {suggestproduct?.SystemSize}</Typography>
                                        </FormControl>
                                    </Box>
                                </>
                            )}
                            {activeStep === 3 && (
                                <>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Primary Amount :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setAmountError('');
                                                    } else {
                                                        setAmountError('Primary Amount can only contain numbers');
                                                    }
                                                }}
                                                value={values.PrimaryAmount}
                                                name="PrimaryAmount"
                                                error={!!AmountError || (touched.PrimaryAmount && !!errors.PrimaryAmount)}
                                                helperText={AmountError || (touched.PrimaryAmount && errors.PrimaryAmount)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Cash Amount :"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setGSTError('');
                                                    } else {
                                                        setGSTError('Cash Amount can only contain numbers');
                                                    }
                                                }}
                                                value={values.CashAmount}
                                                name="CashAmount"
                                                error={!!GSTError || (touched.CashAmount && !!errors.CashAmount)}
                                                helperText={GSTError || (touched.CashAmount && errors.CashAmount)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Total Amount :"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={parseFloat(values.PrimaryAmount || 0) + parseFloat(values.CashAmount || 0)}
                                                name="TotalAmount"
                                                error={!!touched.TotalAmount && !!errors.TotalAmount}
                                                helperText={touched.TotalAmount && errors.TotalAmount}
                                                sx={{ gridColumn: "span 2" }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                            <Typography sx={{ mt: 1 }}> {suggestproduct && suggestproduct.amount ? `Suggested : ${suggestproduct?.amount}`
                                                : " "}</Typography>
                                        </FormControl>

                                    </Box>
                                </>
                            )}
                            {activeStep === 4 && (
                                <>
                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            {values?.userId ? (
                                                <TextField
                                                    margin="dense"
                                                    id="userId"
                                                    name="userId"
                                                    label="Dealer :"
                                                    fullWidth
                                                    variant="filled"
                                                    value={matchedUser?.name || dealerName || ''}
                                                    InputProps={{
                                                        readOnly: true
                                                    }}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                />
                                            ) : (
                                                <TextField
                                                    select
                                                    margin="dense"
                                                    id="userId"
                                                    name="userId"
                                                    label="Dealer :"
                                                    fullWidth
                                                    variant="filled"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.userId || dealerName || ''}
                                                    error={touched.userId && Boolean(errors.userId)}
                                                    helperText={touched.userId && errors.userId}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                >
                                                    {Commmercialdealer.map((dealer) => (
                                                        <MenuItem key={dealer._id} value={dealer._id}>
                                                            {dealer.name}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            )}
                                        </FormControl>
                                    </Box>

                                    <Box
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                        }}
                                    >
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="System Size :"
                                                value={values.SystemSizeKw || 0}
                                                name="SystemSizeKw"
                                                error={!!touched.SystemSizeKw && !!errors.SystemSizeKw}
                                                helperText={touched.SystemSizeKw && errors.SystemSizeKw}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Commission/PerKW:"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        handleChange(e);
                                                        setCommissionPerKWError('');
                                                    } else {
                                                        setCommissionPerKWError('Commission/PerKW can only contain numbers');
                                                    }
                                                }}
                                                value={values.CommissionPerKW}
                                                name="CommissionPerKW"
                                                error={!!CommissionPerKWError || (touched.CommissionPerKW && !!errors.CommissionPerKW)}
                                                helperText={CommissionPerKWError || (touched.CommissionPerKW && errors.CommissionPerKW)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                disabled={!!dealerProduct?.dealerData[0]?.commisionCreatedAt}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Total Commission:"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={(values.SystemSizeKw * values.CommissionPerKW).toFixed(2) === 'NaN' ? '0' : (values.SystemSizeKw * values.CommissionPerKW).toFixed(2)}
                                                name="TotalCommission"
                                                error={!!touched.TotalCommission && !!errors.TotalCommission}
                                                helperText={touched.TotalCommission && errors.TotalCommission}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </Box>

                                </>
                            )}
                        </>
                    )}

                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
                            <Button
                                variant="contained"
                                disabled={activeStep === 0}
                                onClick={handleBack}
                            >
                                Back
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                type="button"
                                onClick={() => handleNext(values)}
                            >
                                {isLastStep ? id ? 'Update' : 'Submit' : 'Next'}
                            </Button>
                        </Stack>
                    </FormControl>

                    <Dialog
                        fullScreen={fullScreen}
                        open={openView}
                        onClose={handleCloseView}
                        aria-labelledby="responsive-dialog-title"
                        maxWidth={"sm"}
                        fullWidth
                    >
                        <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: 'right' }}>
                            <Button
                                onClick={handleDownload}
                                style={{ color: theme.palette.text.primary }}
                                startIcon={<DownloadIcon />}
                                disabled={!viewImage}
                            >
                                Download
                            </Button>
                        </DialogTitle>
                        <DialogContent style={{ backgroundColor: theme.palette.background.purple, display: 'flex', justifyContent: 'center', alignItems: 'center' }} >

                            {viewImage ? (
                                <div style={{ maxWidth: '100%', maxHeight: '80vh' }} >
                                    {viewImage.endsWith('.pdf') ? (
                                        <iframe
                                            src={viewImage}
                                            style={{ width: '800px', height: '80vh', border: 'none' }}
                                            title="PDF Preview"
                                        />
                                    ) : (
                                        <img
                                            src={viewImage}
                                            alt="Uploaded Image"
                                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                            ref={downloadRef}
                                        />
                                    )}
                                </div>
                            ) : (
                                <p>No image to display</p>
                            )}
                        </DialogContent>
                        <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                            <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Stack>
            </form>

        </Box >
    );
}